import { Enum  } from "./Enum";

export const StockSupplierEnum: Enum[] = [
  { id: 'promo', name: 'Promo' },
  { id: 'general', name: 'General' }
];
